import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import { getConfig, loadConfig } from './config/apiConfig';

/*const cognitoAuthConfig : AuthProviderProps = {
  authority: "https://cognito-idp.eu-central-1.amazonaws.com/eu-central-1_7mDGVfwBf",
  client_id: "67uqq7lmeo5kh7adad1c7mnn1f",
  client_secret: "1jcmaa3ji1uul4b9a5sqtrce8si297s8vd777th6f2arj7n1s4o",
  redirect_uri: "http://localhost:3000/callback",
  response_type: "code",
  scope: "openid profile",  
};*/

const renderApp = async () => {

  console.log("Loading config");
  await loadConfig();
  console.log("Config loaded");
  const config = getConfig();
  console.log("Retrieve configuration " + config);

  const cognitoAuthConfig : AuthProviderProps = config.COGNITO_CFG;

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <AuthProvider {...cognitoAuthConfig}>
        <App />
      </AuthProvider>
    </React.StrictMode>
  );

}

renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
